// SecondaryNavbar.jsx
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// import memberstack from '../../memberstack';
// import { deleteUser } from '../../actions/user';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import SettingsModal from '../SettingsModal';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
// import { APP_LOGOUT } from '../../constants/actionTypes';
import {
  StyledAppBar,
  StyledContainer,
  StyledToolbar,
  StyledBox,
  Logo
} from './styles';
import MedicheckLogo from '../../assets/MedicheckLogo.png';


const SecondaryNavbar = ({ open, setOpen }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const [settingsOpen, setSettingsOpen] = useState(false);
  const user = useSelector((state) => state.user);
  console.log("User data from Redux:", user);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenSettings = () => {
       alert('Settings cannot be accessed in demo.')
     };

  const handleLogout = async () => {
    window.location.href = 'https://medicheck.lk';
  };

  return (
    <>
    <StyledAppBar sx={{position:'sticky', top:0, left:0, boxShadow:'0 0 2px 2px #ededed', background:'white', padding:'5px', zIndex:1250}}>
      <StyledContainer maxWidth={false} sx={{padding:'0 !important'}}>
        <StyledToolbar disableGutters sx={{width:'100%'}}>
          {open ? (
            <IconButton  onClick={handleDrawerClose} sx={{marginLeft:{md:'16px', sm:'8px', xs:'4px'}}}>
            <MenuOpenIcon />
            </IconButton>
            ) : (
            <IconButton  onClick={handleDrawerOpen} sx={{marginLeft:{md:'16px', sm:'8px', xs:'4px'}}}>
            <MenuIcon />
            </IconButton>
            )}
          <Logo
                      noWrap
                      sx={{ display: { xs: 'none', md: 'flex' } }}
                    >
                      <img
                        src={MedicheckLogo}
                        alt="Medicheck Logo"
                        style={{ height: '50px', width: 'auto', cursor:'pointer' }}
                      />
                    </Logo>

          {/* AVATAR + DROPDOWN on the RIGHT */}
          <StyledBox sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
            <Avatar alt="User" src={user?.profileImage} slotProps={{img: { referrerPolicy: "no-referrer" }}}/>
            <IconButton onClick={handleOpenMenu}>
              <ArrowDropDownIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem onClick={handleOpenSettings}>Settings</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </StyledBox>
        </StyledToolbar>
      </StyledContainer>
    </StyledAppBar>
    {/* <SettingsModal/> */}
    </>
  );
};

export default SecondaryNavbar;
